import packageJson from '../../../package.json';

function Home() {
    const applicationName = 'Backoffice';

    return (
        <div className="flex flex-col items-center justify-between min-h-screen p-8 text-center text-white bg-gradient-to-br from-emerald-500 via-lime-500 to-green-500">
            <header className="mt-10">
                <h1 className="text-5xl font-extrabold mb-2">{applicationName}</h1>
                <span className="text-sm opacity-80">Version: {packageJson.version}</span>
            </header>

            <main className="flex flex-col items-center justify-center flex-1">
                <p className="text-xl max-w-xl mb-8">
                    Bem-vindo ao {applicationName}. Explore ações e funcionalidades usando o menu lateral.
                </p>
                <button
                    onClick={() => {
                        const userImage = document.querySelector('[data-testid="user-image"]') as HTMLElement;
                        if (userImage) userImage.click();
                    }}
                    className="px-8 py-3 bg-white text-indigo-600 rounded-full font-semibold shadow-lg hover:bg-gray-100"
                >
                    Começar
                </button>
            </main>

            <footer className="mb-4 text-sm opacity-80">
                <p>&copy; {new Date().getFullYear()} Agrolend. All rights reserved.</p>
            </footer>
        </div>
    );
}

export default Home;
